<div [formGroup]="dateForm" *ngIf="dateForm">
  <div class="emtr-datepicker sdps-grid-container sdps-p-around_none sdps-m-around_none">
    <div class="emtr-calender" [ngClass]="{'date-errorHighlight':showError}">
      <span class="timeTextbox">
        <p-floatlabel variant="in">
        <p-datepicker ngDefaultControl #dateEntered  [disabled]="disabled" (keyup)="changeValue($event)" (onClose)="onCloseMethod($event, dateEntered)"  formControlName="date" [showIcon]="true" name="emtr-date" [inputId]="inputId" [minDate]="minDate" [maxDate]="maxDateValue" [readonlyInput]="readonlyInput" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{commonConstants.calendarYear}}" keepInvalid="true"></p-datepicker>
        <label [attr.for]="inputId" [ngClass]="{'labelDisabled': dateForm.controls.date.disabled || disabled}">{{dateLabel}}
          <span *ngIf="showAsterisk" class="sdps-text-market-red">*</span>
        </label>
      </p-floatlabel>
      </span>
    </div>
  </div>

</div>
